import { Cookies } from '@/enums/cookies.enum';

import infoService from '@/services/info.service';
import authService from '@/services/auth.service';
import cookieService from '@/services/cookie.service';
import { useApplicationStore } from '@/stores/application.store';
import { Router, RouteLocationRaw } from 'vue-router';

export interface RatingsResponse {
    averageRating: number;
    numberReviews: number;
    last12MonthAverageRating: number;
    last12MonthNumberReviews: number;
    percentageRecommendation: number;
}

const service = {
    async init() {
        // Print webapp version
        console.log(
            `%c version %c${import.meta.env.VUE_APP_COMMIT_REF || 'develop'}`,
            'padding: 2px; font-size: 12px; background: #128cf4; color:white',
            'padding: 2px; font-size: 12px; background: #d64738; color:white',
        );

        // Start session
        await this.startSession();
        await this.refreshInfo();
    },

    async refreshInfo() {
        const applicationStore = useApplicationStore();
        applicationStore.updateInfo(await infoService.getInfo());
    },

    getUrlSessionId() {
        const regex = /session=(.*?.+(?=&)|.+)/;
        const result = window.location.href.match(regex) || false;

        return result[1];
    },

    async startSession() {
        const hasUrlSession = this.getUrlSessionId();

        if (hasUrlSession) {
            cookieService.set(Cookies.Session, hasUrlSession);
        }

        return await authService.isAuthenticated();
    },

    resolveUrl($router: Router, route: RouteLocationRaw): string {
        return globalThis.location.origin + $router.resolve(route).href;
    },
};

export default service;
